module.exports = __webpack_public_path__ + "img/two.1ea1d146.png";